<!--
  CancelSubscriptionDialog -- shared "Are you sure?" confirm dialog for
  cancelling a subscription.

  This is a DUMB confirm dialog: it owns no business logic and makes no API
  call. On confirm it emits `cancel-subscription` (no payload) and closes; the
  PARENT decides what cancelling means. Three live parents rely on this:

    - PaymentsPage.vue (PR-5)        -> POST /api/distributor/billing/cancel
                                        via billingService.cancelSubscription()
    - DistributorAddEdit.vue         -> legacy /subscription admin cancel
    - DistributorAccountInfo.vue     -> legacy /subscription admin cancel

  Keeping the dialog free of the endpoint call preserves a single shared
  contract across all three surfaces (a previous PR-5 draft self-invoked the
  new endpoint here, which silently re-pointed the two legacy SuperAdmin
  surfaces at the wrong cancel -- a cross-surface money-cancel regression).

  PR-5 of the distributor-payments redesign
  (docs/planning/2026-06-24-distributor-payments-redesign.md -- LOCKED).
  Boulders card: "Subscription and Stripe integration"
  (https://trello.com/c/pTVxuNGQ).
-->
<template>
  <v-dialog v-model="showDialog" persistent max-width="500px">
    <v-card>
      <v-card-title
        ><h1>Subscription</h1>
        <v-spacer />
        <v-btn
          icon
          variant="plain"
          @click="handleCancel"
          data-testid="cancel-subscription-close"
          ><v-icon icon="close" /></v-btn
        ></v-card-title
      >
      <v-divider />
      <v-card-text>
        <div class="text-h6">
          Your subscription is active. We hate to see you go.
          <br />
          <br />
          Canceling stops billing and closes every storefront on the account.
          For 90 days the account is read-only: your team can sign in and view
          stores, orders, batches and reports, but no one can make changes.
          <br />
          To undo it, the account Owner can renew from the Stores list within
          those 90 days. After that the account is closed and no one can sign
          in; its data is kept, not erased.
          <br />
          <br />If you do not want to continue, choose Go back.
        </div>
      </v-card-text>
      <v-card-actions class="py-3 px-3">
        <v-btn
          color="primary"
          class="text-white"
          variant="flat"
          @click="handleCancel"
          data-testid="cancel-subscription-go-back"
        >
          Go back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          @click="handleDelete"
          data-testid="confirm-cancel-subscription"
        >
          Cancel Subscription
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CancelSubscriptionDialog",

  props: {},
  computed: {},

  data() {
    return {
      showDialog: false,
    };
  },
  mounted() {},
  methods: {
    show() {
      this.showDialog = true;
    },

    handleCancel() {
      this.showDialog = false;
    },

    // Emit the confirm event and close. The parent owns the actual cancel
    // (the new billing endpoint on PaymentsPage, the legacy admin cancel on
    // the SuperAdmin distributor-edit surfaces). Event name + (empty) payload
    // are the long-standing contract -- do not change without updating ALL
    // three parents.
    handleDelete() {
      this.$emit("cancel-subscription");
      this.showDialog = false;
    },
  },
};
</script>
<style scoped></style>
